/**
 * Opens Pinterest Studio with pre-filled product data.
 * Stores product context in sessionStorage (handles larger payloads than URL params).
 */
export function openPinterestStudio(navigate, product) {
  const data = {
    title: product.title || '',
    description: product.description || product.sub || '',
    category: product.category || product.type || '',
    keywords: product.keywords || '',
    destinationUrl: product.url || product.destinationUrl || '',
    sourceProductId: product.id || '',
    imageUrl: product.imageUrl || '',
  };
  sessionStorage.setItem('pinterest_studio_product', JSON.stringify(data));
  navigate('/pinterest-studio?tab=create&from=product');
}
